// extracted by mini-css-extract-plugin
export var banner = "_h6-0";
export var closeButton = "_h6-2";
export var greenCheckmark = "_h6-3";
export var hereLink = "_h6-4";
export var titleIcon = "_h6-1";